export const VALIDATIONS = {
  AT_LEAST_ONE_UPPER_CASE: {
    regex: /^(?=.*[A-Z]).+$/gm,
    message: "Require at least one uppercase (A-Z)",
  },
  AT_LEAST_ONE_LOWER_CASE: {
    regex: /^(?=.*[a-z]).+$/gm,
    message: "Require at least one lowercase (a-z)",
  },
  AT_LEAST_ONE_NUMBER: {
    regex: /^(?=.*\\d).+$/gm,
    message: "Require at least one number",
  },
  AT_LEAST_NON_ALPHANUMERIC: {
    regex: /^(?=.*[!@#$%^&*])/gm,
    message: "Require at least one special character",
  },
  PASSWORD: {
    regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%&*])[A-Za-z\d!@#$%&*]{8,}$/gm,
    message: "Password must include a combination of (a-z), (A-Z), (0-9), (!@#$%&*)",
  },
};
